import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";

const getUpdateColumns = (onEdit, onDelete) => {
  return [
    {
      Header: "User ",
      accessor: "username",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      disabled: true,
      dataType: "string",
      controlType: "multipleSelect",
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "username",
        keyDescription: "username",
        values: [],
        url: "user/dropdownList",
      },
    },
    {
      Header: "Department",
      accessor: "department",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "multipleSelect",
      Cell: ({ value }) => <DefaultCell value={value} />,
      options: {
        keyField: "code",
        keyDescription: "description",
        values: [],
        url: "department/listAll",
      },
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      sortDisable: true,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getUpdateColumns,};
